module.exports = __webpack_public_path__ + "img/javascript.6b5bd412.svg";